// Unpublished Work © 2025 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {SearchField, withDebounce} from '@deere/isg.component-library';

export default function Search(props) {
    const {
        handler,
        debounce = 0,
        search,
        translations
    } = props;

    const DebouncedSearchField = React.useMemo(() => withDebounce(SearchField), []);

    return (
        <div
            className='search-bar-div'
            data-testid={'mock-search-container'}
        >
            <DebouncedSearchField
                debounceTimeout={debounce}
                onChange={handler}
                placeholder={translations.SEARCH}
                value={search}
            />
        </div>
    );
}

Search.propTypes = {
    debounce: PropTypes.number,
    handler: PropTypes.func,
    search: PropTypes.string,
    translations: PropTypes.translations
};
